import { Yup } from '../../utils';
import { PROPONENTE_FIELDS } from '../../consts/proponente';

export const formSchemaPrimeiroAcesso = Yup.object().shape({
    [PROPONENTE_FIELDS.CPF_OU_CNPJ]: Yup.string().cnpj().required(),
});
